import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { storageKeys } from '../../../../../../stores/DebuggerStore';
import { BLUE, WHITE } from '../../Styles';
import { StyledButton } from '../Styles';

export const LogVerboseButton = observer(() => {
  const {
    DebuggerStore: { setDebugItem },
  } = useStores();

  return (
    <StyledButton
      bgColor={BLUE}
      color={WHITE}
      onClick={() => {
        setDebugItem(storageKeys.writeLogToDevWindow, true);
        setDebugItem(storageKeys.readLogWhenConnected, true);
        setDebugItem(storageKeys.writeToLogWhenConnected, true);
        setDebugItem(storageKeys.writeLogToConsole, true);
        setDebugItem(storageKeys.sendTimestampsToEngine, false);
        setDebugItem(storageKeys.writeTimestampsToConsole, false);
        setDebugItem(storageKeys.deleteOnBlockChange, true);
        setDebugItem(storageKeys.skipPingPongWhenConnected, true);
        setDebugItem(storageKeys.maxLogStorageSizeInKb, 4000);
        setDebugItem(storageKeys.maxMessageLength, 150);
        setDebugItem(storageKeys.engineLogLevel, 'off');
        setDebugItem(storageKeys.uiLogLevel, 'verbose');
      }}
      style={{ cursor: 'pointer' }}
    >
      Verbose Logging
    </StyledButton>
  );
});

export default LogVerboseButton;
